import * as React from "react";
import { useSelector } from "react-redux";
import { confirmDialogSelector } from "../../../store/helpers/helperSelectors";
import { useStoreDispatch } from "../../../store/hooks";
import { setConfirmDialog } from "../../../store/helpers/helperReducers";
import { setNoOfSelectedRow } from "../../../store/api/devices/reducers";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogAction,
  AlertDialogCancel,
} from "../../ui/alert-dialog";
interface IConfirmDialog {
  children?: React.ReactNode;
  actionName: string;
  handleClickAction: (arg: string) => void;
  sx?: unknown;
}

type CloseReason = "action" | "cancel";

const ConfirmDialog: React.FC<IConfirmDialog> = ({ children, handleClickAction, actionName }) => {
  const dispatch = useStoreDispatch();
  const openConfirmDialog = useSelector(confirmDialogSelector);
  const closeReason = React.useRef<CloseReason>("cancel");
  const actionButtonRef = React.useRef<HTMLButtonElement>(null);

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      const reason = closeReason.current;
      closeReason.current = "cancel";
      dispatch(setConfirmDialog(null));
      if (reason === "action") {
        handleClickAction(actionName.toLowerCase());
      } else {
        dispatch(setNoOfSelectedRow({ deviceRowIds: [], rnRowIds: [], lteCellRowIds: [], nrCellRowIds: [], rfFeedsRowIds: [] }));
        handleClickAction("");
      }
    }
  };

  return (
    <AlertDialog open={!!openConfirmDialog} onOpenChange={handleOpenChange}>
      <AlertDialogContent
        onKeyDown={(e: React.KeyboardEvent<HTMLDivElement>) => {
          if (e.key === "Enter") {
            e.preventDefault();
            actionButtonRef.current?.click();
          }
        }}
      >
        {/* sr-only title required by Radix for accessibility */}
        <AlertDialogTitle className="sr-only">{actionName}</AlertDialogTitle>
        <AlertDialogDescription asChild>
          <div className="text-foreground text-base font-medium break-all overflow-hidden">{children}</div>
        </AlertDialogDescription>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => { closeReason.current = "cancel"; }}>
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            ref={actionButtonRef}
            onClick={() => { closeReason.current = "action"; }}
          >
            {actionName}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default ConfirmDialog;